import type { SharedApiService } from '@albert/shared/services';
import type { CreateCheckoutSessionRequest, CreateCheckoutSessionResponse } from '@albert/shared/types';

export const createCheckoutSession = async (
  apiService: SharedApiService,
  useSetupIntent: boolean,
  data: CreateCheckoutSessionRequest,
) => {
  const checkoutSession = await apiService.post<CreateCheckoutSessionResponse, CreateCheckoutSessionRequest>(
    `/checkout?seti=${Number(useSetupIntent)}`,
    data,
  );

  return checkoutSession;
};
